import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import styles from './styles/user-card-row.module.scss';

/**
 * Key/value row used inside `UserCard` (Figma 5747:1752 / 5747:1758
 * etc.). Label sits on the left in muted slate; value sits on the
 * right in dark navy. The right-hand cell accepts arbitrary
 * `ReactNode` so callers can drop in a `UserStatePill` (User Details
 * State row) or a `Text` placeholder without changing the row API.
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {React.ReactNode | string | number | null | undefined} props.value
 */
function UserCardRow({ label, value }) {
    const isNode = React.isValidElement(value);
    const display = value === null || value === undefined || value === '' ? '—' : value;

    return (
        <div className={styles.row}>
            <Text as={TextAs.SPAN} size={TextSizes.SMALL} className={styles.label}>
                {label}
            </Text>
            {isNode ? (
                <span className={styles.value}>{display}</span>
            ) : (
                <Text as={TextAs.SPAN} size={TextSizes.SMALL} className={styles.value}>
                    {display}
                </Text>
            )}
        </div>
    );
}

export default UserCardRow;
